import { Component, inject, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../core/shared/base.component';
import { CategoryExperts } from '../../../../core/models/categoriesexperts.model';
import { CategoryExpertsService } from '../../../../core/services/categoriesexperts.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoaderService } from '../../../../core/shared/services/loader.service';

@Component({
  selector: 'app-expert-categories-management',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './expert-categories-management.component.html',
  styleUrl: './expert-categories-management.component.scss'
})
export class ExpertCategoriesManagementComponent extends BaseComponent implements OnInit {
  data: CategoryExperts[] = [];
  loading = false;
  selected: any = null;
  isNew = false;

  private service = inject(CategoryExpertsService);
  private loader = inject(LoaderService);

  constructor() {
    super();
  }

  ngOnInit() {
    this.load();
  }

  load() {
    this.loading = true;
    this.loader.show();

    this.service.findAll().subscribe({
      next: (response: any) => {
        this.data = response.data;
        this.loading = false;
        this.loader.hide();
      },
      error: (error) => {
        console.error('Error cargando datos:', error);
        this.loading = false;
        this.loader.hide();
      }
    });
  }

  edit(role: any) {
    this.selected = { ...role };
    this.isNew = false;
  }

  create() {
    this.selected = { name: '', description: '', permissions: [] };
    this.isNew = true;
  }

  save() {
    this.loading = true;
    this.loader.show();

    const saveObservable = this.isNew
      ? this.service.create(this.selected)
      : this.service.update(this.selected.id, this.selected);

    saveObservable.subscribe({
      next: () => {
        this.selected = null;
        this.isNew = false;
        this.loader.hide();
        this.load();
      },
      error: (error) => {
        console.error('Error guardando rol:', error);
        this.loading = false;
        this.loader.hide();
      }
    });
  }

  delete(item: any) {
    this.confirm(`¿Está seguro de que desea eliminar la categoría: <strong>${item.name}</strong>?`, "Eliminar categoría", "Si, eliminar")
      .then(res => {
        if (res.isConfirmed) {
          this.loading = true;
          this.loader.show();

          this.service.delete(item.id).subscribe({
            next: () => {
              this.load();
              this.loading = false;
              this.loader.hide();
            },
            error: (error) => {
              console.error('Error eliminando rol:', error);
              this.loading = false;
              this.loader.hide();
            }
          });
        }
      });

  }

  cancelEdit() {
    this.selected = null;
    this.isNew = false;
  }
}
